const ipoNavigationRoutes = {
  IPO_HOME: "/",
  IPO_APPLICATION_STATUS: "/status",
  IPO_DETAILS: "/:id",
} as const;

export default ipoNavigationRoutes;
